import type { LocationPlan } from "@Light/services/lightTypes";
import { createContext, useContext } from "react";
import type { RenewCustomerState, RenewScreen } from "./types";

export type UseRenew = {
  screens: RenewScreen[];
  nav: { stack: string[]; cursor: number };
  next: () => Promise<void>;
  back: (() => void) | undefined;
  customerState: RenewCustomerState;
  expirationDate: Date;
  earlyTerminationFee: number;
  noOffers: boolean;
  onLogout: (reason?: string) => void;
  currentPlan: LocationPlan;
  transitionDate: Date | null;
  isRecent: boolean;
};

export const RenewContext = createContext<UseRenew | undefined>(undefined);

export function useRenew(): UseRenew {
  const renew = useContext(RenewContext);
  if (!renew) {
    throw new Error("useRenew must be used within a <RenewFlow>");
  }
  return renew;
}

export function useOptionalRenew(): UseRenew | undefined {
  return useContext(RenewContext);
}
